__turbopack_context__.v({
  "footer": "NarvarFooter-module__Ej-mnW__footer",
  "footerPadding": "NarvarFooter-module__Ej-mnW__footerPadding",
  "footerPaddingEmbed": "NarvarFooter-module__Ej-mnW__footerPaddingEmbed",
  "legalColumn": "NarvarFooter-module__Ej-mnW__legalColumn",
  "logoColumn": "NarvarFooter-module__Ej-mnW__logoColumn",
});
